import { Button, Form, Input, message } from 'antd';
import axios from 'axios';
import React from 'react';

function Add({ wid, setR, r }) {
    const [form] = Form.useForm();

    return (
        <Form form={form} layout="vertical" onFinish={(values) => {
            axios.post('section', { ...values, warehouse_id: wid }).then(() => {
                message.success("Seksiya muvaffaqiyatli qo'shildi");
                form.resetFields();
                setR(!r);
            }).catch(() => {
                message.error("Seksiya qo'shishda xatolik");
            });
        }}>
            <Form.Item label="Seksiya nomi" name="name" rules={[{ required: true, message: "Nom kiritilishi shart" }]}>
                <Input placeholder="Seksiya nomini kiriting" />
            </Form.Item>
            <Form.Item label="Seksiya kodi" name="code">
                <Input placeholder="Kodni kiriting (ixtiyoriy)" />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" block>Qo'shish</Button>
            </Form.Item>
        </Form>
    );
}

export default Add;